import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import T from '../../../../../../../common/components/T';
import css from './RelatedProducts.module.scss';
import UserContext, { UserProfileContext } from '../../../../../../../common/utils/getContext';
import { getData } from '../../../../../../../common/utils/router';
import { useWindowDimensions } from '../../../../../../../common/utils/windowDimensions';
import { getSlidesToShow } from './helpers';
import Slider from 'react-slick';
import Product from '../../../../../../../widgets/product/Product/Product';
import classNames from 'classnames';
import { svgSprite } from '../../../../../../../hybrid/wrappers';

export default function RelatedProducts({ dataProduct }) {
    const { userToken, lang, localization } = useContext(UserContext);
    const { profileData } = useContext(UserProfileContext);

    const [relatedProducts, setRelatedProducts] = useState(null);
    const sliderRef = useRef();
    const width = useWindowDimensions();

    const slidesToShow = useMemo(() => getSlidesToShow(width), [width]);

    useEffect(() => {
        (async () => {
            if (dataProduct?.links?.related_products) {
                const getRelatedProducts = await getData(
                    `${dataProduct?.links?.related_products}?page[size]=25&include=media,special_statuses`,
                    userToken,
                    lang,
                    false,
                    profileData?.currency?.code || localization.currency
                );
                if (getRelatedProducts?.data) {
                    setRelatedProducts(getRelatedProducts?.data);
                }
            }
        })();
    }, [lang, localization.currency, dataProduct, userToken, profileData]);

    const sliderSettings = {
        arrows: false,
        dots: false,
        slidesToShow,
        ref: sliderRef
    };

    const isSlider = useMemo(() => relatedProducts?.length > slidesToShow, [relatedProducts, slidesToShow]);

    const sliderArrowHandler = (type) => {
        if (!sliderRef?.current) return;
        switch (type) {
            case 'prev': {
                sliderRef?.current?.slickPrev();
                break;
            }
            case 'next': {
                sliderRef?.current?.slickNext();
                break;
            }
            default:
                break;
        }
    };

    if (!relatedProducts || !relatedProducts?.length) return null;
    return (
        <div className={css.wrapper}>
            <p className={css.lightTitle}>
                <T textName='store-related-products-lighttitle' defaultStr='Products' page='/store' />
            </p>
            <div className={css.content}>
                <div className={css.header}>
                    <p className={css.title}>
                        <T textName='we-recommend-also' defaultStr='Рекомендуем также' page='/store' />
                    </p>
                    <div className={classNames(css.sliderButtons, { [css.dn]: !isSlider })}>
                        <div onClick={() => sliderArrowHandler('prev')} className={classNames('circleButton', css.sliderButton)}>
                            {svgSprite('arrow-left-gt-store')}
                        </div>
                        <div onClick={() => sliderArrowHandler('next')} className={classNames('circleButton', css.sliderButton)}>
                            {svgSprite('arrow-right-gt-store')}
                        </div>
                    </div>
                </div>
                <div className={classNames(css.slider, { [css.grid]: !isSlider })}>
                    {isSlider ? (
                        <Slider {...sliderSettings}>
                            {relatedProducts?.map((product) => (
                                <div key={product.id}>
                                    <Product
                                        product={product}
                                        isAllowAddProduct={true}
                                        setAllowAddProduct={() => {}}
                                        stylesMix={css}
                                    />
                                </div>
                            ))}
                        </Slider>
                    ) : (
                        relatedProducts?.map((product) => (
                            <div key={product.id}>
                                <Product
                                    product={product}
                                    isAllowAddProduct={true}
                                    setAllowAddProduct={() => {}}
                                    stylesMix={css}
                                />
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
}
